import React from 'react';
import NavTagline from '../../../nav-tagline/nav-tagline';
import BodyPassword from '../../../account/BodyPassword';
import Footer from '../../../shared/Footer';


const PasswordChangePreReg = () => (
    <div className="PasswordChangePreReg">
        <NavTagline />
        <section className="layout-container">
            <div className="container">
                <div className="descript-container">
                    <div className="form-title g-clr">Change Password</div>
                        Please take a moment to create your unique password. Use the temporary password from your registration email as your current password.
                </div>
                <BodyPassword />
            </div>
        </section>
        <Footer />
  </div>
);

export default PasswordChangePreReg;
